import memoize from 'lodash/memoize';
import dayjs, { Dayjs } from 'dayjs';
import { Validator } from 'redux-form';

const defaultMessage = 'Please enter a valid date';

export const dateFormat = memoize(
  (message: string = defaultMessage): Validator =>
    (value: Dayjs | string | number | Date) =>
      dayjs(value).isValid() ? undefined : message,
);
